export { default } from './account-page';
